<template>
  <el-select
    :disabled = "disabled"
    filterable
    remote
    value-key="id"
    v-model="shop"
    :remote-method="loadShopList"
    placeholder="输入店铺名字搜索"
    @change="onChange"
    clearable>
    <el-option v-for="item in shopList"
      :key="item.id"
      :label="item.name + '(' + item.id + ')'"
      :value="item" />
  </el-select>
</template>

<script>
export default {
    name : 'TicketFormShop',

    props : ['value'],

    data() {
      return {
        disabled : false,
        shop : {},
        shopList : []
      }
    },

    watch : {
      value() {
        this.onValue();
      }
    },

    mounted() {
      this.onValue();
    },

    methods : {
      onValue() {
        if ( !this.value ) {
          return;
        }

        var _this = this;
        sdk.TicketShopApi().findById({
          id : _this.value
        }).then(res => {
          _this.shopList = [ res ];
          _this.shop = res;
        });
      },

      loadShopList( _query ) {
        var _this = this;

        sdk.TicketShopApi().search({
          key : _query
        }).then(res => {
          _this.shopList = res || [];
        });
      },

      onChange() {
        // console.log('#45 shop change', this.shop, this);

        this.$emit('input', this.shop.id);

        this.$emit('change', this.shop);
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormShop.vue